import { render, staticRenderFns } from "./echarts-disc.vue?vue&type=template&id=2d806e5c&scoped=true"
import script from "./echarts-disc.vue?vue&type=script&lang=ts"
export * from "./echarts-disc.vue?vue&type=script&lang=ts"
import style0 from "./echarts-disc.vue?vue&type=style&index=0&id=2d806e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d806e5c",
  null
  
)

export default component.exports